import React from 'react';

export const Logo = () => {
  return (
    <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'>
      <g id='logo_Ellipse_0.8'>
        <path d='M16 .81C24.38.81 31.19 7.62 31.19 16S24.38 31.19 16 31.19.81 24.38.81 16 7.62.81 16 .81m0-.8C7.17.01.01 7.17.01 16S7.17 31.99 16 31.99 31.99 24.83 31.99 16 24.83.01 16 .01z' />
      </g>
      <g id='logo_Rd_Rectangle_0.8'>
        <path d='M27.75 3.03c.68 0 1.22.55 1.22 1.22v23.49c0 .68-.55 1.22-1.22 1.22H4.25c-.68 0-1.22-.55-1.22-1.22V4.25c0-.68.55-1.22 1.22-1.22h23.5m0-.8H4.25c-1.12 0-2.02.91-2.02 2.02v23.49c0 1.12.91 2.02 2.02 2.02h23.49c1.12 0 2.02-.91 2.02-2.02V4.25c.01-1.11-.9-2.02-2.01-2.02z' />
      </g>
      <g id='logo_Rectangle_0.8'>
        <path d='M12.99 12.99h5.99v5.99h-5.99z' fill='#e92344' />
      </g>
    </svg>
  );
};
